import { Button } from 'react-bootstrap'
import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import { useStateValue } from '@State'
import { client } from '@Utils'
import { toast } from '@CommonComponents/toast'
import { LoadingWave } from '../../components'

const ConnectResourceComp = ({history}) => {
  const [currentState, dispatch] = useStateValue()
  const [loading, setLoading] = useState(false)
  let contextId = window.location.pathname.split('/')[4]
  useEffect(() => {
    async function getConnectResourceData() {
      try {
        const resp = await client.get(`/lti13/resource_selection.get_instructor_data/-/`)
        await dispatch({
          type: 'updateInstructorData',
          payload: {
            ...resp.data,
          },
        })
      } catch (err) {
        let errMsg = err
        if (err.response) {
          errMsg = err.response.data.error
        }
        toast.error(errMsg)
      }
    }
    getConnectResourceData()
  }, [])

  const resetApp = () => {
    history.replace(
      `/lti13/resource_selection/-/`
    )
  }


  const getLmsNameFromCode = (lmsCode) => {
    switch (lmsCode) {
      case 'canvas':
        return 'Canvas'
      case 'learn':
        return 'Blackboard'
      case 'BlackboardLearn':
        return 'Blackboard'
      default:
        return 'your LMS'
    }
  }

  const createConnection = async (cnumToCopy, history) => {
    setLoading(true)
    try {
      setLoading(true)
      const resp = await client.post(`/lti13/resource_selection.create_new_course/-/`, {
        source_coursenum: cnumToCopy,
        contextId: contextId,
        manuallyEnteredCoursenum: !currentState.useCourseDropDown
      })
      dispatch({
        type: 'updateConnectedCourses',
        connectedCourses: resp.data.connected_courses
      })
      setLoading(false)
      history.push(
        `/lti13/resource_selection/-/`
      )
      toast.success("Your resource has been successfully linked.")
    } catch (err) {
      setLoading(false)
      toast.error(err.response.data.error)
    }
  }

  if (loading) {
    return (
      <React.Fragment>
        <h2>
          {currentState.useCourseDropDown ? 'Copying and Connecting Selected Resource' : 'Connecting Selected Resource'}
        </h2>
        <LoadingWave />
      </React.Fragment>
    )
  }

  return (
    <React.Fragment>
      {currentState.connectedCourses.length === 0 && (
        <div className="px-3">
          <h2>Welcome, {currentState.instrFirstName}</h2>
          <h4>{currentState.useCourseDropDown ?
          `Select a MyEducator resource to copy and connect to ${getLmsNameFromCode(currentState.lmsCode)}.` :
          `Select an existing MyEducator resource to connect to ${getLmsNameFromCode(currentState.lmsCode)}.`}
          </h4>
        </div>
      )}
      <ResourceFormFields resetApp={resetApp}/>
      <div className="px-3">
        <a
          onClick={() => {
            dispatch({
              type: 'updateCourseDropDown',
              useCourseDropDown: !currentState.useCourseDropDown,
            })
            dispatch({
              type: 'coursenumToCopy',
              coursenumToCopy: '',
            })
          }}
        >
          {currentState.useCourseDropDown ? "Enter a resource number instead" : "Select from a dropdown"}
        </a>
      </div>
      <div className="px-3">
        <Button
          disabled={currentState.coursenumToCopy === ''}
          className="btn btn-success btn-myed btn-success-myed mt-4"
          onClick={() =>
            createConnection(currentState.coursenumToCopy, history)
          }
        >
          Create Connection
        </Button>
      </div>
    </React.Fragment>
  )
}

ConnectResourceComp.propTypes = {
  history: PropTypes.object.isRequired,
}

export const ConnectResource = withRouter(ConnectResourceComp)


const ResourceFormFields = ({resetApp}) => {
  const [currentState, dispatch] = useStateValue()

  if (currentState.instrCourses.length < 1 ) {
    return (
      <div className="px-3">
        <p>
          The email address <i>{currentState.instrEmail}</i> does not belong
          to any MyEducator resources.
        </p>
        <p>
          Please contact your MyEducator representative or email us at{' '}
          <a href="mailto:support@myeducator.com">support@myeducator.com</a>{' '}
          for assistance.
        </p>
      </div>
    )
  }
  return (
      <div className="px-3 mt-4 d-flex justify-content-between align-items-start">
        {currentState.useCourseDropDown ? (
          <div className="flex-grow-1 mr-3">
            <select
              className="w-100"
              onChange={event =>
                dispatch({
                  type: 'coursenumToCopy',
                  coursenumToCopy: event.target.value,
                })
              }
              aria-label="select course to copy"
            >
              <option value="">Select an available resource</option>
              {currentState.instrCourses.map((childCourse, i) => (
                <option key={i} value={childCourse.coursenum}>
                  {`${childCourse.course_title} Created: ${childCourse.create_date}`}
                </option>
              ))}
            </select>
          </div>
        ) : (
          <div className="flex-grow-1 mr-3">
            <label htmlFor="coursenum">Resource Number:</label>
            <input
              id="coursenum"
              onChange={event =>
                dispatch({
                  type: 'coursenumToCopy',
                  coursenumToCopy: event.target.value,
                })
              }
              type="text"
              className="w-100"
            />
          </div>
        )}
        {currentState.connectedCourses.length > 0 && (
          <div className="btn btn-link text-dec-none flex-shrink-0" onClick={resetApp}>
            <div className="fa-solid fa-times fa-fw" /> Cancel
          </div>
        )}
      </div>
  )
}
